import AssignEmployeeToPropertiesModal from "./AssignEmployeeToPropertiesModalContainer";
import AssignEmployeeToPropertiesSuccessModal from "./AssignEmployeeToPropertiesSuccessModalContainer";

export default AssignEmployeeToPropertiesModal;
export { AssignEmployeeToPropertiesSuccessModal };
